'use client';

import { getCookie } from 'cookies-next';
import { useEffect } from 'react';
import { useProperty } from '@/forApp/states/propertyState/propertyState';
import { useUser } from '@/forApp/states/userState/userState';
import BaseLink from '@/shared/Links/BaseLink';
import BaseLinkOpenModal from '@/shared/Links/BaseLinkOpenModal';
import styles from './styles.module.css';

const AuthBlock = () => {
  const { user, getUser } = useUser();
  const { fetchTypes, types } = useProperty();
  let token = getCookie('cg-token');

  useEffect(() => {
    // eslint-disable-next-line
    token = getCookie('cg-token');
    if (!user && token) getUser();
  }, [user]);

  useEffect(() => {
    if (!types.length) fetchTypes().then();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [types.length]);

  const isAuth = user && token;
  return isAuth ? (
    <div className={styles.infoBlock}>
      <BaseLink href={'/profile'} text={'Личный кабинет'} color={'white'} />
    </div>
  ) : (
    <div className={styles.infoBlock}>
      <BaseLinkOpenModal
        href={'/auth?mode=register'}
        text={'Зарегистрироваться'}
        color={'white'}
        modal={{ name: 'AuthModal', type: 'register' }}
      />
      <BaseLinkOpenModal
        href={'/auth'}
        text={'Войти'}
        color={'white'}
        modal={{ name: 'AuthModal', type: 'login' }}
      />
    </div>
  );
};

export default AuthBlock;
